import { useGetNewAuthToken } from '@/app/digdashHook';
import { buildIFrameDigdashLink, isDigdashLink } from '@/components/common/iFrame.utils';
import type { IFrameLinkParams } from '@/models/common.type';

type Props = {
  params?: IFrameLinkParams;
  link: string;
};

const IFrameContent = ({ params, link }: Props) => {
  const iframeWidth = params?.width || '100%';
  const iframeHeight = params?.height ?? '200px';

  const isDigdash = isDigdashLink(link);

  const { data: digdash } = useGetNewAuthToken({ skip: !isDigdash });

  const finalLink = isDigdash ? buildIFrameDigdashLink(link, digdash) : link;

  return (
    <iframe
      src={finalLink}
      title={params?.title}
      allowFullScreen
      style={{
        border: 'none',
        display: 'block',
        width: iframeWidth,
        height: iframeHeight,
      }}
    />
  );
};

export default IFrameContent;
